module.exports = __webpack_public_path__ + "img/what-is-a-mechanical-license.ac86f90d.jpg";